<template>
    <div>   
        <v-divider></v-divider>  
        <mbs-page-tab 
            :items="MY_LINKS"/>   
        <v-divider></v-divider>  
        <v-divider></v-divider>  
        <v-divider></v-divider>  
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12"> 
                    <v-card :min-height="vsh/2" >   
                        <mbs-item-manager
                            :table_title="'Manage '+ThisStockLevel?.stock_level_type_name+' ('+ThisStockLevel?.name+')'"
                            :table_title_icon="'mdi-ballot-recount-outline'"
                            :add_vertical_lines="true"
                            :row_click="true"
                            v-model="input"
                            :table_tabs="TABLE_TABS"
                            :top_label="false"
                            :name_items="ThisStockLevel?ThisStockLevel.name+' '+NAME_ITEMS:NAME_ITEMS"
                            :name_item="NAME_ITEM+'--'"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="DATA.FIELDS.items"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="StockLevelItems"  
                            :is_joined="true"  
                            :path_item="PATH_ITEM"  
                            :select_items="DataSource"  
                            :total_item_values="TOTAL_ITEM_VALUES"  

                            :table_actions="TableActions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />  
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  

        <!-- //DIALOGS -->
        <div>
            <div v-if="ADDING_ITEM">
                <mbs-item-manager 
                    :show="false" 
                    :add_item_action="ADDING_ITEM.add_item_action"
                    :name_items="ADDING_ITEM.names"
                    :name_item="ADDING_ITEM.name"
                    :value_items="ADDING_ITEM.values"
                    :value_item="ADDING_ITEM.value"
                    :field_items="ADDING_ITEM.fields"   
                    :path_item="ADDING_ITEM.path"  
                    :select_items="Selectors"  
                    @ADDED="ADDED" 
                /> 
            </div>

            <!-- ADD STOCK LEVEL ITEM-->
            <div v-if="dialog_add_stock_level_item">
                <v-dialog 
                    v-model="dialog_add_stock_level_item"
                    scrollable   
                    :persistent="false" :overlay="false"
                    max-width="700px"
                    transition="dialog-transition" >
                    <form @submit.prevent="ADD_STOCK_LEVEL_ITEM(input)"> 
                        <v-card  exact>
                            <v-card-title class="primary white--text"  >
                                Add Stock Level Item 
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="dialog_add_stock_level_item = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text>
                                    <div class="pa-5">
                                        <mbs-input-fields
                                            v-model="input"
                                            :name_items="NAME_ITEMS"
                                            :name_item="NAME_ITEM"
                                            :value_items="VALUE_ITEMS"
                                            :value_item="VALUE_ITEM"
                                            :field_items="DATA.FIELDS.item_stock_level"
                                            :select_items="DataSource" 
                                            />  
                                    </div>
                                </v-card-text>
                                <v-card-actions class="pa-5"> 
                                    <v-btn class="px-9" large @click="dialog_add_stock_level_item = false" color="primary" >Cancel</v-btn>
                                    <v-flex > 
                                        <v-btn large width="100%" type="submit" color="secondary" class="ml-2">Add Item</v-btn>
                                    </v-flex>
                                </v-card-actions>
                        </v-card> 
                    </form> 
                </v-dialog>  
            </div>
            
            <!-- UPDATE STOCK LEVEL ITEM-->
            <div v-if="dialog_update_stock_level_item">
                <v-dialog 
                    v-model="dialog_update_stock_level_item"
                    scrollable   
                    :persistent="false" :overlay="false"
                    max-width="700px"
                    transition="dialog-transition" >
                    <form @submit.prevent="UPDATE_STOCK_LEVEL_ITEM(input)"> 
                        <v-card  exact>
                            <v-card-title class="primary white--text"  >
                                Update Stock Level Item 
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="dialog_update_stock_level_item = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text>
                                    <div class="pa-5">
                                        <mbs-input-fields
                                            v-model="input"
                                            :name_items="NAME_ITEMS"
                                            :name_item="NAME_ITEM"
                                            :value_items="VALUE_ITEMS"
                                            :value_item="VALUE_ITEM"
                                            :field_items="DATA.FIELDS.item_stock_level"
                                            :select_items="DataSource" 
                                            />  
                                    </div>
                                </v-card-text>
                                <v-card-actions class="pa-5"> 
                                    <v-btn class="px-9" large @click="dialog_update_stock_level_item = false" color="primary" >Cancel</v-btn>
                                    <v-flex > 
                                        <v-btn large width="100%" type="submit" color="secondary" class="ml-2">Update Item</v-btn>
                                    </v-flex>
                                </v-card-actions>
                        </v-card> 
                    </form> 
                </v-dialog>  
            </div>
        </div>
    </div> 
</template>

<script> 
    import DATA from '../../../../../plugins/DATA'
    import {mapState,mapGetters } from "vuex"
    import { mdiFormatListGroupPlus } from '@mdi/js';
    import { mdiProgressTag } from '@mdi/js';
    let PAGE_NAME = DATA.ITEMS.ITEM_DEPARTMENTS.values    
    export default {
        name:PAGE_NAME, 
        props:['id','stock_level_code'], 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
                input:{},
                dialog_add_stock_level_item:false,
                dialog_update_stock_level_item:false,
                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
                ADDING_ITEM:null, 
                
                DATA:DATA,
                TOTAL_ITEM_VALUES:[ 
                    // {name:'Closing Stock (QTY)',value:'number_quantity',show_value:"number_quantity"},
                    // {name:'Total Cost',value:'number_total_cost',show_value:'number_total_cost_',money:true},
                ], 
            }
        },
        created() {
            try { 
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try { 
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                }) 
                this.FEEDBACKS(1000)  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            MY_LINKS(){  
                let stock_levels = this.StockLevels 
                
                if(!stock_levels){return null}
                let allLinks = []
                stock_levels.forEach(element => {
                    allLinks.push({
                        ...element,
                        name:element.name+"",
                        link:this.MBS.actions.COMPANY_LINK("/stock/stock-levels/"+element.code,true),
                        icon:'link',
                        // image:'/future_tours/svg/SVG/my_parcel.svg',
                        image_background_color:'primary lighten-2',
                        image_size:'80',
                        
                    })
                });  
                return allLinks
            }, 
            PATH_ITEM(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true) 
                return path
            },
            /////////
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Brands: state=> state.items[(DATA.ITEMS.BRANDS.values).toUpperCase()],
                Manufacturers: state=> state.items[(DATA.ITEMS.MANUFACTURERS.values).toUpperCase()], 
                TaxGroups: state=> state.app[(DATA.ITEMS.TAX_GROUPS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                SelectedCompany: state=> state.items["SELECTED_COMPANY"],   
            }),  
            StockOutletsData(){ 
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets 
                return items
            }, 
            ItemsData(){ 
                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                if (JoinedItems) {
                    return JoinedItems
                } 
                return Items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },
            StockLevelItems(){
                const stock_level = this.ThisStockLevel
                const stock_level_code = stock_level?.code
                const items = this.InventoryItems
                if(!items || !stock_level_code){return null}
                const filtered = items?.filter(item=>item[stock_level_code+"_status"])
                console.log(filtered,'f.......................v');
                
                return filtered
            },
            ThisStockLevel(){ 
                let stock_level_code = this.stock_level_code
                let stock_levels = this.StockLevels
                if(!stock_levels || !stock_level_code){return null}
                let item = stock_levels.find(department=>department.code == stock_level_code)
                console.log(item,'stock_level_code...f.');
                return item
            }, 
            StockLevels(){ 
                const settings = this.CompanySettings
                const stock_levels_ob = settings?.STOCK_LEVELS
                const stock_levels = stock_levels_ob?Object.entries(stock_levels_ob).map(([key,value])=>({...value,key})):null
                const joined = this.MBS.actions.JOIN_STOCK_LEVELS(stock_levels) 
                return joined?joined:stock_levels
            },
            DataSource(){ 
                let Outlets = this.StockOutletsData 
                let Items = this.ItemsData  
                let ItemCategories = this.ItemCategories
                let Brands = this.Brands
                let Manufacturers = this.Manufacturers
                let TaxGroups = this.TaxGroups
                let ThisStockLevel = this.ThisStockLevel
                return{
                    Outlets: Outlets,
                    Items: Items,
                    ItemCategories: ItemCategories,
                    Brands: Brands,
                    Manufacturers: Manufacturers, 
                    TaxGroups: TaxGroups, 
                    ThisStockLevel: ThisStockLevel, 
                }
            },
             
            TABLE_TABS(){
                const stock_level = this.ThisStockLevel
                const stock_level_code = stock_level?.code
                return [
                    {name:"All Items",show_if:(this_,item)=>{  
                            return !item.item_kits
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},
                    
                    {name:"Full L.",show_if:(this_,item)=>{  
                            return item[stock_level_code+"_status"] =="full"
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},   
                    {name:"Average L.",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item["number_quantity"])>0?true:false
                            return item[stock_level_code+"_status"] =="average"
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Remind L.",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item["number_quantity"])>0?true:false
                            return item[stock_level_code+"_status"] =="remind"
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Stop L.",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item["number_quantity"])>0?true:false
                            return item[stock_level_code+"_status"] =="stop"
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},   
                ]
            },
            HEADER_ITEMS(){
                const input = this.input
                const current_table_tab = input?input.current_table_tab:null
                const stock_level = this.ThisStockLevel
                const stock_level_code = stock_level?.code
                const stock_level_type_key = stock_level?.stock_level_type_key
                const outlet_code = stock_level?.outlet_code

                let opening_stock = "all_opening_stocks"
                let receive_stock = "number_stock_receives"
                let transfer_stock = "number_stock_transfers"
                let return_stock = "number_stocks_returns"
                let adjust_stock = "number_stock_adjustments"
                let return_sales = "number_returned_sales"
                let sold_stock = "number_sales"
                let stock = "number_quantity"
                let restock = stock_level_code+"_restock"
                let restock_ = stock_level_code+"_restock_"

                let ordering_remind_level = stock_level_code+"_ordering_remind_level"
                let average_level = stock_level_code+"_average_level"
                let full_level = stock_level_code+"_full_level"
                let stop_selling_level = stock_level_code+"_stop_selling_level"

                let status = stock_level_code+"_status"
              
                
                if (stock_level_type_key == "outlet_stock_level") {
                    opening_stock = outlet_code+"_all_opening_stocks"
                    receive_stock = outlet_code+"_number_stock_receives"
                    transfer_stock = outlet_code+"_number_stock_transfers"
                    return_stock = outlet_code+"_number_stocks_returns"
                    adjust_stock = outlet_code+"_number_stock_adjustments"
                    return_sales = outlet_code+"_number_returned_sales"
                    sold_stock = outlet_code+"_number_sales"
                    stock = outlet_code+"_number_quantity"
                }else if (stock_level_type_key == "item_stock_level") {
                    opening_stock = outlet_code+"_all_opening_stocks"
                    receive_stock = outlet_code+"_number_stock_receives"
                    transfer_stock = outlet_code+"_number_stock_transfers"
                    return_stock = outlet_code+"_number_stocks_returns"
                    adjust_stock = outlet_code+"_number_stock_adjustments"
                    return_sales = outlet_code+"_number_returned_sales"
                    sold_stock = outlet_code+"_number_sales"
                    stock = outlet_code+"_number_quantity"
                }else{

                }

                let headers = [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:false},  
                    {id:0,name:"",value:'icon_image',color:"",size:35,tile:true,show:false},   
                    {id:0,name:"Barcode",value:"code_",align:"center",show:true},   
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Category",value:"category_name",show:true}, 
                    {id:0,name:"Category Code",value:"category_code",show:false}, 
                    {id:0,name:"Brand",value:"brand_name",show:false}, 
                    {id:0,name:"Brand Code",value:"brand_code",show:false}, 
                    {id:0,name:"Manufacturers",value:"manufacturer_name",show:false}, 
                    {id:0,name:"Manufacturer Code",value:"manufacturer_code",show:false}, 
                    
                    {id:0,name:"Cost Price",value:"cost_price_",class:' b ',show:false}, 
                    {id:0,name:"Retail Price",value:"retail_price_",class:' b ',show:false}, 
                    {id:0,name:"Wholesale Price",value:"wholesale_price",class:' b ',show:false}, 

                    {id:0,name:"Stop",value:stop_selling_level,align:"center",class:' b ',show:true}, 
                    {id:0,name:"Remind",value:ordering_remind_level,align:"center",class:' b ',show:true}, 
                    {id:0,name:"Average",value:average_level,align:"center",class:' b ',show:true}, 
                    {id:0,name:"full",value:full_level,align:"center",class:' b ',show:true}, 

                    {id:0,name:"Open Stock",value:opening_stock,align:"center",class:' b ',show:false}, 
                    {id:0,name:"Received",value:receive_stock,align:"center",class:' b ',show:false}, 
                    {id:0,name:"Transferred",value:transfer_stock,align:"center",class:' b ',show:false}, 
                    {id:0,name:"Return Stock",value:return_stock,align:"center",class:' b ',show:false}, 
                    {id:0,name:"Adjustments",value:adjust_stock,align:"center",class:' b ',show:false}, 
                    {id:0,name:"Return Sales",value:return_sales,align:"center",class:' b ',show:false}, 
                    {id:0,name:"Sold",value:sold_stock,align:"center",cellClass:'',class:' b ',show:false}, 
                    {id:0,name:"Stock",value:stock,align:"center",cellClass:'',class:' b ',show:true}, 
                    {id:0,name:"Restock",value:restock_,align:"center",cellClass:'',class:' b ',show:true}, 
                    {id:0,name:"Restock",value:status,align:"center",cellClass:'',class:' b ',show:true}, 

                    


                    // {id:0,name:"Status",value:(this_,item)=>{
                    //     const select_items = this_?.SELECT_ITEMS
                    //     const stock_level = select_items?.ThisStockLevel
                    //     const stock_level_code = stock_level?.code
                    //     const stock_level_type_key = stock_level?.stock_level_type_key
                    //     const stock_outlet_code = stock_level?.stock_outlet?.code
                    //     const path_data = stock_level_type_key == "outlet_stock_level"?item?.outlets?.[stock_outlet_code]:item 
                    //     const value = item?.[stock_level_code+"_status"]  
                    //     return value
                    // },align:"center",cellClass:'',class:' b ',show:true}, 
                        
                    {id:0,name:"Tax Group",value:"tax_group_name",align:"center",show:false}, 
                    {id:0,name:"Tax Group Code",value:"tax_group_code",align:"center",show:false}, 
                    {id:0,name:"action",align:"right",show:false,item:[  
                        {name:"Update Stock Level",action:"update_stock_level_item",icon:"mdi-pencil"},
                        {name:"Remove Stock Level",action:"remove_stock_level_item",icon:"mdi-delete"},
                    ]}, 
                ] 
                return headers
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:true},  
                    {id:0,name:"Barcode",value:"code",align:"center",show:true},      
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Category",value:"category_code",show:true}, 
                    {id:0,name:"Brand",value:"brand_code",show:true}, 
                    {id:0,name:"Cost",value:"cost_price",show:true}, 
                    {id:0,name:"Retail",value:"retail_price",show:true}, 
                    {id:0,name:"Wholesale",value:"wholesale_price",show:true}, 
                    {id:0,name:"Tax",value:"tax",show:true}, 
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },  
            TableActions(){
                const stock_level = this.ThisStockLevel
                const stock_level_code = stock_level?.code
                const stock_level_type_key = stock_level?.stock_level_type_key
                let action = [{type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"}]
                if (stock_level_type_key == "item_stock_level") {
                    action = [
                        {type:"action",btn:false,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},
                        {type:"action",btn:true,icon:"mdi-plus-box-multiple",action:"add_stock_level_item",color:"secondary", outlined:false,  text:"Add Item"},
                    ]
                }
                let actions = [
                    ...action,    
                    {type:"action",btn:true,icon:'mdi-scale-balance',actions:[
                        {icon:"mdi-microsoft-excel",action:"import_excel",text:'Import Excel'},
                        {icon:"mdi-file-download-outline",action:"download_balance_excel_template",text:'Download Excel Template'},
                    ],color:"secondary", outlined:false,  text:"Balance Inventory"},  
                    {type:"action",btn:true,icon:'mdi-dolly',actions:[
                        {icon:"mdi-microsoft-excel",action:"import_excel",text:'Import Excel'},
                        {icon:"mdi-file-download-outline",action:"download_restock_excel_template",text:'Download Excel Template'},
                    ],color:"secondary", outlined:false,  text:"Restock to Full"},    
                    {type:"action",icon:mdiProgressTag,action:"sync_stock_levels",color:"secondary", outlined:false,  text:"Sync Stock Level"},  
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ]
                return  actions
            },
            
        },
        methods: {  
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action("Item Data","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "sync_stock_levels") {
                        this.CONFIRM_SYNC_STOCK_LEVELS()
                    } else if (action == "add_stock_level_item") {
                        this.ON_ADD_STOCK_LEVEL_ITEM()
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ITEM_ACTION(action,item,option){
                try {     
                    console.log(action,'***************');
                    if (action == "on_row_clicked") {
                         
                    }else if (action == "select_item") {
                         
                    }else if (action == "edit_item") {
                         
                    }else if (action == "update_stock_level_item") {
                        this.ON_UPDATE_STOCK_LEVEL(item)
                    }else if (action == "remove_stock_level_item") {
                        this.REMOVE_STOCK_LEVEL_ITEM(item)
                    }else{}
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            CONFIRM_SYNC_STOCK_LEVELS(){
                try {   
                    const stock_level = this.ThisStockLevel
                    const stock_level_name = stock_level?.name
                    const stock_level_type_name = stock_level?.stock_level_type_name 
                    let mbs_text = this.MBS.text.item_action(stock_level_type_name,"Sync")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=CONFIRM-SYNC-STOCK-LEVEL", 
                            stock_level
                        } 
                    })   
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            
            async SYNC_STOCK_LEVELS(stock_level){
                try {   
                    const items = this.InventoryItems  
                    const res = await this.MBS.actions.SYNC_STOCK_LEVELS({stock_level,items})
                    console.log(res,'res..........++');
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SYNC_STOCK_LEVELS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            ON_ADD_STOCK_LEVEL_ITEM(){
                try { 
                    this.dialog_add_stock_level_item = true
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_ADD_STOCK_LEVEL_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ADD_STOCK_LEVEL_ITEM(input){
                try { 
                    console.log(input,'a-------------------');
                    let mbs_text = this.MBS.text.item_action("Stock Level Item","Add")
                    const stock_level = this.ThisStockLevel
                    const stock_level_code = stock_level?.code
                    const data = {
                        item_key : input?.item_key,
                        full_level : input?.full_level,
                        average_level : input?.average_level,
                        ordering_remind_level : input?.ordering_remind_level,
                        stop_selling_level : input?.stop_selling_level,
                        stock_level_code
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=ADD-STOCK-LEVEL-ITEM", 
                            data:data
                        } 
                    }) 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_STOCK_LEVEL_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            SUBMIT_STOCK_LEVEL_ITEM(data){
                try { 
                    const item_path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    const item_link = item_path+data?.item_key+"/"
                    console.log(item_link,'item_link..........');
                    
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Adding..."
                    })
                    const detailed_data = {
                        // customer_stock_level:true
                    }
                    detailed_data[data?.stock_level_code+"_full_level"] = data?.full_level
                    detailed_data[data?.stock_level_code+"_average_level"] = data?.average_level
                    detailed_data[data?.stock_level_code+"_ordering_remind_level"] = data?.ordering_remind_level
                    detailed_data[data?.stock_level_code+"_stop_selling_level"] = data?.stop_selling_level
                    detailed_data[data?.stock_level_code+"_customer_stock_level"] = true

                    this.$store.dispatch('fi_update',{    
                        action:DATA.ITEMS.ITEMS.values,
                        path:item_link, 
                        data:detailed_data,  
                    }).then(res=>{
                        console.log(res,'res.......');
                        console.log(item_link,'item_link.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Added")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        this.dialog_add_stock_level_item = false
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Added")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })

                    console.log(data,'on ss.......................');
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_STOCK_LEVEL_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            
            
            ON_UPDATE_STOCK_LEVEL(item){
                try { 
                    const stock_level = this.ThisStockLevel
                    const stock_level_code = stock_level?.code
                    this.input = {
                        item_key:item?.key,
                        full_level:item[stock_level_code+"_full_level"],
                        average_level:item[stock_level_code+"_average_level"],
                        ordering_remind_level:item[stock_level_code+"_ordering_remind_level"],
                        stop_selling_level:item[stock_level_code+"_stop_selling_level"],
                    }
                    this.dialog_update_stock_level_item = true
                    console.log(item,'up...................');
                    console.log(this.input,'this.input...................');
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_UPDATE_STOCK_LEVEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_STOCK_LEVEL_ITEM(input){
                try { 
                    console.log(input,'a-------------------');
                    let mbs_text = this.MBS.text.item_action("Stock Level Item","Update")
                    const stock_level = this.ThisStockLevel
                    const stock_level_code = stock_level?.code
                    const data = {
                        item_key : input?.item_key,
                        full_level : input?.full_level,
                        average_level : input?.average_level,
                        ordering_remind_level : input?.ordering_remind_level,
                        stop_selling_level : input?.stop_selling_level,
                        stock_level_code
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=UPDATE-STOCK-LEVEL-ITEM", 
                            data:data
                        } 
                    }) 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_STOCK_LEVEL_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_UPDATE_STOCK_LEVEL_ITEM(data){
                try { 
                    const item_path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    const item_link = item_path+data?.item_key+"/"
                    console.log(item_link,'item_link..........');
                    
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Adding..."
                    })
                    const customer_stock_level = data?.customer_stock_level==undefined?true:data?.customer_stock_level
                    const detailed_data = {
                    }
                    detailed_data[data?.stock_level_code+"_full_level"] = data?.full_level
                    detailed_data[data?.stock_level_code+"_average_level"] = data?.average_level
                    detailed_data[data?.stock_level_code+"_ordering_remind_level"] = data?.ordering_remind_level
                    detailed_data[data?.stock_level_code+"_stop_selling_level"] = data?.stop_selling_level
                    detailed_data[data?.stock_level_code+"_customer_stock_level"] = customer_stock_level

                    console.log(detailed_data,'detailed_data-------++');
                    

                    this.$store.dispatch('fi_update',{    
                        action:DATA.ITEMS.ITEMS.values,
                        path:item_link, 
                        data:detailed_data,  
                    }).then(res=>{
                        console.log(res,'res.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Updated")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        this.dialog_update_stock_level_item = false
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Updated")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })

                    console.log(data,'on ss.......................');
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_STOCK_LEVEL_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            REMOVE_STOCK_LEVEL_ITEM(input){
                try { 
                    console.log(input,'a-------------------');
                    let mbs_text = this.MBS.text.item_action("Stock Level Item","Delete")
                    const stock_level = this.ThisStockLevel
                    const stock_level_code = stock_level?.code
                    const data = {
                        item_key : input?.key,
                        full_level : null,
                        average_level : null,
                        ordering_remind_level : null,
                        stop_selling_level : null,
                        customer_stock_level:false,
                        stock_level_code
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=UPDATE-STOCK-LEVEL-ITEM", 
                            data:data
                        } 
                    }) 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_STOCK_LEVEL_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
          
            
            ADDED(res){
                try { 
                    this.RELOAD_ITEMS()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADDED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            RELOAD_ITEMS(){
                try {
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Refresh..."
                    })
                    this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.ITEMS.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    }).then(res=>{
                        console.log(res,'res.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },

            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=RELOAD-ITEMS') {
                            if (action.YES) {
                                this.RELOAD_ITEMS()
                            } else {
                                
                            }
                        }if (action.code ===PAGE_NAME+'=CONFIRM-SYNC-STOCK-LEVEL') {
                            if (action.YES) {
                                this.SYNC_STOCK_LEVELS(action?.stock_level)
                            } else {
                                
                            }
                        }if (action.code ===PAGE_NAME+'=ADD-STOCK-LEVEL-ITEM') {
                            if (action.YES) {
                                this.SUBMIT_STOCK_LEVEL_ITEM(action?.data)
                            } else {
                                
                            }
                        }if (action.code ===PAGE_NAME+'=UPDATE-STOCK-LEVEL-ITEM') {
                            if (action.YES) {
                                this.SUBMIT_UPDATE_STOCK_LEVEL_ITEM(action?.data)
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            if (!gettingItems) {
                                this.PAGE_LOAD =true
                            }  
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },  
        },
        beforeDestroy(){
            try { 
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch: {  
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            }, 
        },
    }
</script>
 
